import { createSimplePageStrategy } from './simple-page.strategy-helper';

export const AffiliateProgramSeoStrategy = createSimplePageStrategy(
  'affiliateProgram',
  'affiliate-program',
  '/affiliate-program'
);
